import { render } from "./ChangeRoleRequest.vue?vue&type=template&id=3747ba50"
import script from "./ChangeRoleRequest.vue?vue&type=script&lang=js"
export * from "./ChangeRoleRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__